//#region src/variants/variants_loader.js
var variants_loader_default = {
	defaults: { props: { size: { tokenCategory: "icon-size" } } },
	default: { props: {
		size: { initialValue: "500" },
		ariaLabel: { initialValue: "Processing" }
	} },
	small: { props: {
		size: { initialValue: "100" },
		ariaLabel: { initialValue: "Processing" }
	} },
	large: { props: {
		size: { initialValue: "400" },
		ariaLabel: { initialValue: "Processing" }
	} }
};
//#endregion
export { variants_loader_default as default };

//# sourceMappingURL=variants_loader.js.map